// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hxh5","toggleWrap":"styles_toggleWrap__CY2k4","content":"styles_content__1zzpy","selectAreaCode":"styles_selectAreaCode__fayWM"};